import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../Core/Image';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  padding: 40px 0;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 70px 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    padding: 100px 0;
  }
`;

export const Img = styled(Image)`
  display: none;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: block;
    position: absolute;
    right: -5%;
    width: 400px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 450px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    width: 550px;
    right: -6.5%;
  }
`;

export const Content = styled.div`
  position: relative;
  width: 100%;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 60%;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const Title = styled.h2`
  margin-bottom: 1rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 2rem;
  }

  &.velvet {
    color: ${themeGet('colors.velvet')};
  }
`;
